import React from 'react';

export default function GeneralPaymentRecieved({ form, setForm, error, setError }) {
	return <div></div>;
}
